function init() {
	const navigationBlock = document.getElementById('progressive-navigation');

	if (!navigationBlock) {
		return;
	}

	const levelTwoHeaders = document.querySelectorAll('.content h2');
	const visibleStatuses = [];
	let initialised = false;

	levelTwoHeaders.forEach((header, index) => {
		header.style.position = 'relative';
		const anchor = document.createElement('a');
		anchor.setAttribute('id', `progressive-nav-${index}`);
		anchor.style.position = 'absolute';
		anchor.style.top = '-125px';
		header.appendChild(anchor);

		const trigger = document.createElement('span');
		trigger.dataset.anchorIndex = index;
		header.appendChild(trigger);

		const link = document.createElement('a');
		link.setAttribute('href', `#progressive-nav-${index}`);
		link.dataset.navIndex = index;
		link.innerText = header.textContent;

		const listItem = document.createElement('li');
		listItem.appendChild(link);

		navigationBlock.appendChild(listItem);
	});

	let observer = new IntersectionObserver(entries => {
		entries.forEach((entry) => {
			visibleStatuses[parseInt(entry.target.dataset.anchorIndex)] = entry.isIntersecting;
		});

		initialised = true;

		if (visibleStatuses.some(status => status)) {
			visibleStatuses.forEach((intersecting, index) => {
				const navigationBlock = document.querySelector(`[data-nav-index="${index}"]`);

				if (intersecting) {
					navigationBlock.classList.add('text-violet');
				} else {
					navigationBlock.classList.remove('text-violet');
				}
			});
		}
	}, {rootMargin: '-100px'});

	const updatedLevelTwoHeaders = document.querySelectorAll('.content h2 span');

	updatedLevelTwoHeaders.forEach((header) => {
		observer.observe(header)
	} );
}

export default init;
